import React, { ForwardedRef } from "react";

import { ButtonGroupProps } from "./ButtonGroup.types";
import { useStyles } from "./ButtonGroup.styles";

function ButtonGroup(
  props: ButtonGroupProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { size, variant, children, ...other } = props;

  const classes = useStyles();

  const childrenWithProps = React.Children.map(children, (child: any) => {
    const childProps: {
      size?: ButtonGroupProps["size"];
      variant?: ButtonGroupProps["variant"];
    } = {};
    if (size) {
      childProps.size = size;
    }
    if (variant) {
      childProps.variant = variant;
    }
    return React.cloneElement(child, childProps);
  });

  return (
    <div {...other} ref={ref} className={classes.root}>
      {childrenWithProps}
    </div>
  );
}

export default React.forwardRef(ButtonGroup);
